console.log("Hello from webpack bundle!");

// SCSSファイルをインポート
import "./scss/main.scss";

// HEIC変換ライブラリ（動的インポート）
// import { heicTo } from "heic-to";
// window.heicTo = heicTo;

// モジュールのインポート
import { currentSelectedTemplate, imageTransforms, editingImageIndex, tempTransform, updateImageTransform, clearEditingState, albumImages } from "./modules/state.js";

import { loadAllTransformsFromHiddenInputs, debugTransformState, updateHiddenTransformInput } from "./modules/imageTransforms.js";

import { fetchTemplates, handleTemplateSelection } from "./modules/templateManager.js";

import { drawImageToPopupCanvas, drawMainAlbumCanvas, getClickedImageIndex } from "./modules/canvasRenderer.js";

import { showPreviewModal, hidePreviewModal, showAlbumPreviewModal, hideAlbumPreviewModal, saveAlbumPreviewChanges } from "./modules/modalManager.js";

import { observeUploadContainers } from "./modules/imageUploadObserver.js";
import { setupEditControls, checkCoverFit } from "./modules/editControls.js";
import { initializeLayoutData, observeTextInputs, drawAllTextElements } from "./modules/textRenderer.js";
import { setupTemplateSelectionModal, restoreSelectedTemplate, debugSelectBoxState, confirmTemplateSelection, cancelTemplateSelection } from "./modules/templateSelectionManager.js";
import { generateAlbumPDF, generateAlbumPDFWithMPDF, generateAlbumPDFWithTCPDF } from "./modules/pdfGenerator.js";

document.addEventListener("DOMContentLoaded", async () => {
  // DOM要素の取得
  const previewModal = document.getElementById("albumImagePreviewModal");
  const albumPreviewModal = document.getElementById("albumPreviewModal");
  const popupCanvas = document.getElementById("popupPreviewCanvas");
  const closeModalButton = document.querySelector(".album-modal-close-button");
  const cancelPreviewButton = document.getElementById("cancelPreviewChangesButton");
  const albumPreviewButton = document.getElementById("btn_preview");
  const downloadButton = document.getElementById("btn_download");
  const mainAlbumCanvas = document.getElementById("mainAlbumCanvas");
  const mainAlbumCanvasMessage = document.getElementById("mainAlbumCanvasMessage");
  const templateSelectElement = document.getElementById("mase_case_entry_type_a1_itemStrVarchar02");
  const templateThumbnailImageElement = document.getElementById("templateThumbnailImage");
  const templateThumbnailPlaceholderElement = document.getElementById("templateThumbnailPlaceholder");

  // Canvas コンテキストの取得
  let popupCtx = null;
  if (popupCanvas) {
    popupCtx = popupCanvas.getContext("2d");
  } else {
    console.error("Popup Canvasが見つかりません。");
  }

  let mainCtx = null;
  if (mainAlbumCanvas) {
    mainCtx = mainAlbumCanvas.getContext("2d");
    if (mainAlbumCanvasMessage) {
      mainAlbumCanvasMessage.textContent = "画像をアップロードし、テンプレートを選択すると、ここにプレビューが表示されます。";
    }
  } else {
    console.error("メインプレビューCanvas (#mainAlbumCanvas) が見つかりません。");
  }

  // メインCanvas描画のラッパー関数
  const drawMainAlbumCanvasWrapper = () => {
    drawMainAlbumCanvas(mainCtx, mainAlbumCanvas, mainAlbumCanvasMessage);
  };

  // ページ読み込み時にhidden inputから変換情報を復元
  console.log("[初期化] ページ読み込み時の変換情報復元を開始");
  const loadedCount = loadAllTransformsFromHiddenInputs();

  if (loadedCount > 0) {
    console.log(`[初期化] ${loadedCount}個の変換情報を復元しました`);
  } else {
    console.log("[初期化] 復元された変換情報はありません。全てデフォルト値を使用します");
  }

  // デバッグ情報を表示（開発時のみ）
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    debugTransformState();
  }

  // モーダル関連のイベントリスナー
  if (closeModalButton) {
    closeModalButton.addEventListener("click", () => {
      hidePreviewModal(previewModal, popupCtx, popupCanvas);
    });
  }

  if (cancelPreviewButton) {
    cancelPreviewButton.addEventListener("click", () => {
      hidePreviewModal(previewModal, popupCtx, popupCanvas);
    });
  }

  if (previewModal) {
    previewModal.addEventListener("click", (event) => {
      if (event.target === previewModal) {
        hidePreviewModal(previewModal, popupCtx, popupCanvas);
      }
    });
  }

  // 保存ボタンのイベントリスナー
  const saveChangesButton = document.getElementById("savePreviewChangesButton");
  if (saveChangesButton) {
    saveChangesButton.addEventListener("click", () => {
      const editingIndexStr = previewModal ? previewModal.dataset.editingImageIndex : null;
      console.log(`[saveChanges] 保存処理開始 - editingIndexStr: ${editingIndexStr}, editingImageIndex: ${editingImageIndex}`);
      console.log(`[saveChanges] 保存前のtempTransform:`, JSON.stringify(tempTransform));

      // editingImageIndexが有効で、tempTransformが存在する場合に保存
      if (editingImageIndex !== null && tempTransform) {
        console.log(`[saveChanges] 保存前のimageTransforms[${editingImageIndex}]:`, JSON.stringify(imageTransforms[editingImageIndex]));

        // 変更を保存
        updateImageTransform(editingImageIndex, tempTransform);
        console.log(`画像 ${editingImageIndex + 1} の変換情報を保存:`, imageTransforms[editingImageIndex]);
        console.log(`[saveChanges] 保存後のimageTransforms[${editingImageIndex}]:`, JSON.stringify(imageTransforms[editingImageIndex]));

        // hidden inputに変換情報を保存
        updateHiddenTransformInput(editingImageIndex, imageTransforms[editingImageIndex]);

        // メインキャンバスを再描画
        drawMainAlbumCanvasWrapper();
      } else {
        console.warn(`[saveChanges] 保存条件が満たされていません - editingImageIndex: ${editingImageIndex}, tempTransform:`, tempTransform);
      }
      hidePreviewModal(previewModal, popupCtx, popupCanvas);
    });
  }

  // アルバムプレビューボタンのイベントリスナー
  if (albumPreviewButton) {
    albumPreviewButton.addEventListener("click", () => {
      console.log("[albumPreviewButton] アルバムプレビュー・写真調整ボタンがクリックされました");

      // テンプレートが選択されているかチェック
      if (!currentSelectedTemplate) {
        alert("まずテンプレートを選択してください。");
        return;
      }

      showAlbumPreviewModal(albumPreviewModal, drawMainAlbumCanvasWrapper);
    });
  }

  // アルバムプレビューモーダルのイベントリスナー
  const albumPreviewCloseButton = albumPreviewModal ? albumPreviewModal.querySelector(".album-modal-close-button") : null;
  if (albumPreviewCloseButton) {
    albumPreviewCloseButton.addEventListener("click", () => {
      hideAlbumPreviewModal(albumPreviewModal, drawMainAlbumCanvasWrapper);
    });
  }

  if (albumPreviewModal) {
    albumPreviewModal.addEventListener("click", (event) => {
      if (event.target === albumPreviewModal) {
        hideAlbumPreviewModal(albumPreviewModal, drawMainAlbumCanvasWrapper);
      }
    });
  }

  // アルバムプレビューモーダルの保存・キャンセルボタン
  const albumPreviewSaveButton = document.getElementById("albumPreviewSaveButton");
  const albumPreviewCancelButton = document.getElementById("albumPreviewCancelButton");

  if (albumPreviewSaveButton) {
    albumPreviewSaveButton.addEventListener("click", () => {
      saveAlbumPreviewChanges(albumPreviewModal);
    });
  }

  if (albumPreviewCancelButton) {
    albumPreviewCancelButton.addEventListener("click", () => {
      hideAlbumPreviewModal(albumPreviewModal, drawMainAlbumCanvasWrapper);
    });
  }

  // メインCanvas上での画像クリック検知
  if (mainAlbumCanvas) {
    mainAlbumCanvas.addEventListener("click", (event) => {
      // メインプレビューモーダルが表示されている時のみ処理
      if (!albumPreviewModal || albumPreviewModal.style.display === "none") {
        return;
      }

      // テンプレートが選択されていない場合は処理しない
      if (!currentSelectedTemplate) {
        return;
      }

      const rect = mainAlbumCanvas.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const clickY = event.clientY - rect.top;

      console.log(`[mainCanvasClick] クリック位置: (${clickX}, ${clickY})`);

      // クリック位置がどの画像スロットに該当するかを判定
      const clickedImageIndex = getClickedImageIndex(clickX, clickY, mainAlbumCanvas);

      if (clickedImageIndex !== null) {
        console.log(`[mainCanvasClick] 画像 ${clickedImageIndex + 1} がクリックされました`);

        // 該当する画像がアップロードされているかチェック
        const formattedImageIndex = (clickedImageIndex + 1).toString().padStart(2, "0");
        const previewImageContainer = document.getElementById(`js_dd_show_mase_case_entry_type_a1_itemFile${formattedImageIndex}`);

        if (previewImageContainer) {
          const existingImage = previewImageContainer.querySelector("img");

          if (existingImage && existingImage.src && existingImage.src.startsWith("data:image/")) {
            // 個別編集モーダルを開く
            const modalErrorMessage = document.getElementById("modalErrorMsg");
            if (modalErrorMessage) modalErrorMessage.remove();
            if (previewModal) previewModal.setAttribute("data-editing-image-index", (clickedImageIndex + 1).toString());

            console.log(`[mainCanvasClick] 画像 ${clickedImageIndex + 1} の編集モーダルを開きます`);
            drawImageToPopupCanvas(popupCtx, popupCanvas, existingImage.src, (clickedImageIndex + 1).toString());
            showPreviewModal(previewModal);
          } else {
            alert(`画像 ${clickedImageIndex + 1} がまだアップロードされていません。`);
          }
        }
      }
    });
  }

  // テンプレート選択ドロップダウンのイベントリスナー
  if (templateSelectElement) {
    templateSelectElement.addEventListener("change", (event) => {
      const selectedTemplateId = event.target.value;
      handleTemplateSelection(selectedTemplateId, templateThumbnailImageElement, templateThumbnailPlaceholderElement);
      console.log("Template selected:", selectedTemplateId, currentSelectedTemplate);
      drawMainAlbumCanvasWrapper(); // メインプレビューを更新
    });
  }

  // 画像アップロード監視を開始
  observeUploadContainers(drawMainAlbumCanvasWrapper);

  // 編集コントロールボタンの設定
  setupEditControls(popupCanvas);

  // checkCoverFit関数をpopupCanvasに追加
  if (popupCanvas) {
    popupCanvas.checkCoverFit = () => checkCoverFit(popupCanvas);
  }

  // layout.jsonを読み込み
  await initializeLayoutData();

  // テキスト入力の監視を開始
  const drawAllTextElementsWrapper = async () => {
    if (mainCtx && mainAlbumCanvas && currentSelectedTemplate) {
      drawAllTextElements(mainCtx, mainAlbumCanvas, currentSelectedTemplate);
    }
  };

  // グローバルに参照を保存（drawMainAlbumCanvas関数内でテキスト描画を呼び出すため）
  window.drawAllTextElementsInternal = drawAllTextElementsWrapper;

  observeTextInputs(drawAllTextElementsWrapper);

  // テンプレートを読み込み
  try {
    await fetchTemplates();

    // テンプレート選択モーダルのセットアップ
    setupTemplateSelectionModal();

    // 既存の選択状態を復元
    restoreSelectedTemplate();

    // デバッグ情報を表示（開発時のみ）
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      debugSelectBoxState();
    }

    // 初期描画のために一度呼び出す (テンプレート未選択状態)
    drawMainAlbumCanvasWrapper();
  } catch (error) {
    if (mainAlbumCanvasMessage) {
      mainAlbumCanvasMessage.textContent = "テンプレート情報の読み込みに失敗しました。";
    }
  }

  // PDFダウンロードボタンのイベントリスナー
  if (downloadButton) {
    // 既存のイベントリスナーを削除（HMRによる重複を防ぐ）
    downloadButton.removeEventListener("click", downloadButton._pdfClickHandler);

    // 新しいイベントハンドラーを作成
    const pdfClickHandler = async () => {
      console.log("[downloadButton] PDFダウンロードボタンがクリックされました");

      try {
        // テンプレートが選択されているかチェック
        if (!currentSelectedTemplate) {
          alert("まずテンプレートを選択してください。");
          return;
        }

        // 画像がアップロードされているかチェック
        const hasImages = albumImages.some((img) => img !== null);
        if (!hasImages) {
          alert("写真をアップロードしてください。");
          return;
        }

        // 本番用PDF生成を実行
        await generateAlbumPDF();
      } catch (error) {
        console.error("[downloadButton] PDF生成エラー:", error);
        // エラーメッセージは generateAlbumPDF 内で表示される
      }
    };

    // ハンドラーを要素に保存（削除時に参照できるように）
    downloadButton._pdfClickHandler = pdfClickHandler;

    // イベントリスナーを追加
    downloadButton.addEventListener("click", pdfClickHandler);
  }
});
